import { AGB_URL, DATENSCHUTZ_URL, IMPRESSUM_URL, KONTAKT_EMAIL } from "@/lib/api";

const linkCls = "hover:text-gold transition-colors duration-500";

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream mt-24" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-6 py-16 grid gap-10 sm:grid-cols-2">
        <div>
          <p className="font-serif text-3xl text-gold mb-4">Canto Dei</p>
          <p className="text-sm text-cream/70 leading-relaxed max-w-sm">
            Individuelle personalisierte Trauersongs – erschaffen mit Würde,
            Respekt und höchstem Qualitätsanspruch.
          </p>
        </div>
        <div className="sm:text-right space-y-2 text-sm text-cream/80">
          <p>info@canto-dei.com</p>
          <p>+41 (0) 78 441 14 82</p>
          <div className="flex flex-wrap sm:justify-end gap-x-6 gap-y-2 pt-4 text-cream/70">
            <a href={IMPRESSUM_URL} target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="footer-impressum-link">
              Impressum
            </a>
            <a href={AGB_URL} target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="footer-agb-link">
              AGB
            </a>
            <a href={DATENSCHUTZ_URL} target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="footer-datenschutz-link">
              Datenschutzerklärung
            </a>
            <a href={`mailto:${KONTAKT_EMAIL}`} className={linkCls} data-testid="footer-kontakt-link">
              Kontakt
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
